import { EntityRequestCostsacct } from "../../entity/EntityRequestCostsacct";

export class DtoRequestCostsacctsPutRes extends EntityRequestCostsacct {}
